import { RequisitionsPageComponent } from "./requisitions-page.component";
import { RequisitionCardModule } from "./requisitionCard/requisition-card.module";
export var RequisitionsPageModule = angular
    .module('requisitionsPage', [RequisitionCardModule])
    .config(['$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('missioncontrol.requisitions', {
            url: '/requisitions',
            component: RequisitionsPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                requisitionStatesArray: null,
                loginParamsObject: null,
                userParamsObject: null
            }
        });
    }
])
    .component(RequisitionsPageComponent.selector, RequisitionsPageComponent.component)
    .constant('REQUISITIONSCONSTANTS', {
    CONTROLLER: {
        GET_ALL_JOBS: 'api/job/userJobs',
        UPDATE_JOB_STATUS: 'api/job/status',
        GET_CLIENTS_RECRUITERS_BY_ROLE: 'api/job/clientandrecruitersbyroles',
        GET_CLIENT_ROLE_BY_RECRUITER: 'api/job/clientandrolebyrecruiters',
        GET_ROLE_RECRUITER_BY_CLIENT: 'api/job/roleandrecruitersbyclients',
        GET_SALARY_DURATION_OPTIONS: 'api/requisition/salarydurationoptions'
    }
})
    .name;
//# sourceMappingURL=requisitions-page.module.js.map